import { api } from "@/lib/api";

export interface AgentProjectPayload {
  id?: string;
  name: string;
}

export interface AgentProjectUpdatePayload {
  name?: string | null;
}

export const chatProjectsService = {
  listProjects: async () => {
    const response = await api.get("/api/v1/chat/projects");
    return response.data as { projects: any[] };
  },

  createProject: async (payload: AgentProjectPayload) => {
    const response = await api.post("/api/v1/chat/projects", payload);
    return response.data as any;
  },

  updateProject: async (projectId: string, payload: AgentProjectUpdatePayload) => {
    const response = await api.patch(`/api/v1/chat/projects/${projectId}`, payload);
    return response.data as any;
  },

  deleteProject: async (projectId: string) => {
    await api.delete(`/api/v1/chat/projects/${projectId}`);
  },
};

